import { FC } from "react";
import { InputText } from "../../../../components/input";
import { CreateNotification } from "../../../../components/notifier";

import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";

export const ContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: "Users",
    label: "Người sử dụng",
    isVisibleOnList: true,
  },
  {
    name: "NameSupplies",
    label: "Mã nhân viên",
    isVisibleOnList: true,
  },
  {
    name: "WorkingDepartment",
    label: "Bộ phận công tác",
    isVisibleOnList: true,
  },
  {
    name: "SuggestionDetails",
    label: "Chi tiết đề nghị",
    isVisibleOnList: true,
  },
  {
    name: "DegreeTraining",
    label: "Lý do",
    isVisibleOnList: true,
  },
];

export const ContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      if (!values.Users || !values.NameSupplies || !values.WorkingDepartment || !values.SuggestionDetails)
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
      else props.onSubmit(values);
    },
  });

  return (
    <div className="Form__add-new py-4">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>
      <InputWraper inputProps={getInputProps("Users")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("NameSupplies")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper
        inputProps={getInputProps("WorkingDepartment")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />
      <InputWraper
        inputProps={getInputProps("SuggestionDetails")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />
      <InputWraper inputProps={getInputProps("DegreeTraining")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
